import { MdArrowRightAlt } from "react-icons/md";
import "./BackParameters.css";
import { useLocation } from "react-router-dom";
import moment from "moment";
const BackParameters = ({ ts_value }: any) => {

  console.log("BACK PARAMS TS",ts_value);
  
  const { pathname } = useLocation();
  let pathType: any = ((pathname.split('/')).pop())?.toLowerCase();

  let model_open_date:any  = ts_value['open_date'] === undefined ? ts_value['dt_date'] : ts_value['open_date']
 

  let openDateIsTodayOrNot:any  = model_open_date === moment(new Date()).format('YYYY-MM-DD');
  let productCodeKey:any = openDateIsTodayOrNot === true ? 's_code' : 'identifier'

  return (
    <>
      {ts_value === undefined ?
        ""
        :
        <section className="sectionGapParameter">
          {ts_value?.target && ts_value?.stoploss ? (
            <span>
              <span> <span className="font-semibold">{pathType === 'live' ? (ts_value?.time) : (ts_value?.dt_open_time)}, </span> <span style={{ fontFamily: "monospace" }}>Target</span></span>  <MdArrowRightAlt /> {String(ts_value[productCodeKey])?.slice(0, -1) === 'AIONIFKKI' ? ts_value?.target.toFixed(2) : ts_value?.target.toFixed(2)}, <span style={{ fontFamily: "monospace" }}>Stoploss</span> <MdArrowRightAlt /> {String(ts_value[productCodeKey])?.slice(0, -1) === 'AIONIFKKI' ? ts_value?.stoploss.toFixed(2) : ts_value?.stoploss.toFixed(2)}
            </span>
          ) : ts_value?.target ? (
            <span> <span className="font-semibold">{pathType === 'live' ? (ts_value?.time) : (ts_value?.dt_open_time)}, </span><span style={{ fontFamily: "monospace" }}>Target</span> <MdArrowRightAlt /> {String(ts_value[productCodeKey])?.slice(0, -1) === 'AIONIFKKI' ? ts_value?.target.toFixed(2) : ts_value?.target.toFixed(2)}</span>
          ) : ts_value?.stoploss ? (
            <span><span className="font-semibold">{pathType === 'live' ? (ts_value?.time) : (ts_value?.dt_open_time)}, </span><span style={{ fontFamily: "monospace" }}> Stoploss</span> <MdArrowRightAlt /> {String(ts_value[productCodeKey])?.slice(0, -1) === 'AIONIFKKI' ? ts_value?.stoploss.toFixed(2) : ts_value?.stoploss.toFixed(2)}</span>
          ) : (
            ""
          )}
        </section>
      }
    </>
  );
};

export default BackParameters;